import { Property } from '../../types/property';

const getSellingAgent = (property: Property): string => {
  if (property.listingLogos && property.listingLogos.length > 2) {
    return '';
  }

  if (property.agents && property.agents.length === 1) {
    return property.agents[0].organisation;
  }

  if (property.account && !property.account.developer) {
    return property.account.organisation;
  }

  return '';
};

export default getSellingAgent;
